import isMobile from 'ismobilejs';
import { FILTERS_IN_TITLE, MANUFACTURER_KEY, MAX_FILTERS_IN_TITLE, MMS_GROUPS_KEY, MODEL_KEY } from '../constants/search';
import config from '../../../config/app.config';
import { toJS, ObservableMap } from 'mobx';
import CookieUtils from './CookieUtils';
import { isAutomatedAgent } from './BotDetection';
export const findDeepestValueByKeyName = (obj, keyName) => {
    const currentValue = obj[keyName];
    if (typeof currentValue !== 'object') {
        return currentValue;
    }
    if (currentValue !== null && typeof currentValue === 'object') {
        return findDeepestValueByKeyName(currentValue, keyName);
    }
};
export const transformErrorMessages = (messages, lang) => {
    const substitutes = {
        en: { pattern: /(:attribute) (field)?/, replacement: ' field ' },
        de: { pattern: /(Feld(er)?)? (:attribute) (Feld(er)?)?/, replacement: ' Feld ' },
        ru: { pattern: /([Пп]ол.?)? (:attribute) ([Пп]ол.?)?/, replacement: ' $1$3 ' }
    };
    Object.keys(messages).forEach((name) => {
        const msg = messages[name];
        if (typeof msg === 'object') {
            transformErrorMessages(messages[name], lang);
        }
        else {
            const substitute = substitutes[lang];
            messages[name] = msg.replace(substitute.pattern, substitute.replacement).trim();
        }
    });
    return messages;
};
// function return list of filter for inject in title
export const filtersInTitle = (filters) => {
    const result = [];
    const pushInResult = (value) => {
        if (result.length < MAX_FILTERS_IN_TITLE && value && value.length > 0) {
            result.push(value);
        }
    };
    FILTERS_IN_TITLE.forEach((filter) => {
        if (filter === MMS_GROUPS_KEY) {
            filters.get(filter).forEach((MmsObject) => {
                pushInResult(MmsObject[MANUFACTURER_KEY].value);
                pushInResult(MmsObject[MODEL_KEY].value);
            });
        }
        else {
            const getValue = filters.get(filter).value;
            Array.isArray(getValue) ? getValue.forEach((value) => pushInResult(value)) : pushInResult(getValue);
        }
    });
    return result;
};
export const priceParse = (value) => {
    return value ? Number.parseFloat(value) : null;
};
export const preloadImages = (imageSources, onLoad, onError) => {
    let loadedImages = 0;
    let hasError = false;
    const onLoadImage = () => {
        loadedImages = loadedImages + 1;
        if (loadedImages === imageSources.length && !hasError) {
            onLoad();
        }
    };
    const onErrorLoadImage = () => {
        hasError = true;
        onError();
    };
    imageSources.forEach((src) => {
        const image = new Image();
        image.onload = onLoadImage;
        image.onerror = onErrorLoadImage;
        image.src = src;
        if (image.complete) {
            image.onload = null;
            onLoadImage();
        }
    });
};
export const getDeviceType = () => {
    if (isMobile.phone)
        return 'phone';
    if (isMobile.tablet)
        return 'tablet';
    return 'desktop';
};
export const MARKETING_PARAM_REGISTRY = [
    // auto.de legacy (unchanged — still first-class, exact-match now instead of prefix-match)
    { param: 'source', key: 'source', source: 'url' },
    { param: 'campaign', key: 'campaign', source: 'url' },
    { param: 'medium', key: 'medium', source: 'url' },
    { param: 'content', key: 'content', source: 'url' },
    { param: 'term', key: 'term', source: 'url' },
    { param: 'reference', key: 'reference', source: 'url' },
    { param: 'adgroupid', key: 'adgroupid', source: 'url' },
    { param: 'keyword', key: 'keyword', source: 'url' },
    // standard UTM (previously not captured at all)
    { param: 'utm_source', key: 'utmSource', source: 'url' },
    { param: 'utm_medium', key: 'utmMedium', source: 'url' },
    { param: 'utm_campaign', key: 'utmCampaign', source: 'url' },
    { param: 'utm_id', key: 'utmId', source: 'url' },
    { param: 'utm_term', key: 'utmTerm', source: 'url' },
    { param: 'utm_content', key: 'utmContent', source: 'url' },
    // Google Ads
    { param: 'gclid', key: 'gclid', source: 'url' },
    { param: 'gbraid', key: 'gbraid', source: 'url' },
    { param: 'wbraid', key: 'wbraid', source: 'url' },
    // Meta — fbclid from the landing URL, fbc/fbp from the Meta Pixel's own first-party cookies
    { param: 'fbclid', key: 'fbclid', source: 'url' },
    { param: '_fbc', key: 'fbc', source: 'cookie' },
    { param: '_fbp', key: 'fbp', source: 'cookie' },
    // TikTok — ttclid from the URL, _ttp from the TikTok pixel's cookie
    { param: 'ttclid', key: 'ttclid', source: 'url' },
    { param: '_ttp', key: 'ttp', source: 'cookie' },
    // Microsoft Advertising
    { param: 'msclkid', key: 'msclkid', source: 'url' },
    // LinkedIn Conversions API
    { param: 'li_fat_id', key: 'liFatId', source: 'url' },
    // Pinterest (URL click-matching param only — see doc-comment above)
    { param: 'epik', key: 'epik', source: 'url' },
    // X (Twitter) Ads
    { param: 'twclid', key: 'twclid', source: 'url' },
    // Reddit Ads
    { param: 'rdt_cid', key: 'rdtCid', source: 'url' },
    // Criteo / RTB House (existing partner IDs, unchanged)
    { param: 'rtbh_pld', key: 'rtbh_pld', source: 'url' },
    { param: 'cto_pld', key: 'cto_pld', source: 'url' },
    { param: 'rtbhc', key: 'rtbhc', source: 'url' },
];
/** auto.de legacy vs. standard-UTM pairs that MUST agree — flags parameterConflict without
 *  ever overwriting either raw value (both stay in the payload untouched either way). */
const CONFLICT_PAIRS = [
    ['source', 'utmSource'],
    ['medium', 'utmMedium'],
    ['campaign', 'utmCampaign'],
];
function readCookieValue(name) {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : undefined;
}
function getUtmQueryParameter() {
    const query = window.location.search;
    const queryString = /^[?]/.test(query) ? query.slice(1) : query;
    const urlParams = queryString ? queryString.split('&').reduce((params, param) => {
        const [key, value] = param.split('=');
        if (!key) {
            return params;
        }
        params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
        return params;
    }, {}) : {}; // eslint-disable-line indent,@typescript-eslint/indent
    const result = {};
    MARKETING_PARAM_REGISTRY.forEach(({ param, key, source }) => {
        const value = source === 'url' ? urlParams[param] : readCookieValue(param);
        if (value !== undefined)
            result[key] = value;
    });
    let parameterConflict = false;
    CONFLICT_PAIRS.forEach(([legacyKey, utmKey]) => {
        if (result[legacyKey] !== undefined && result[utmKey] !== undefined && result[legacyKey] !== result[utmKey]) {
            parameterConflict = true;
        }
    });
    if (parameterConflict)
        result.parameterConflict = true;
    return result;
}
export function setUtmParameters() {
    const captured = getUtmQueryParameter();
    if (!Object.keys(captured).length)
        return; // nothing new this pageview — leave any earlier cookie untouched
    // Merge onto whatever the marketing cookie already held (per doc §4.3: a direct/internal
    // navigation, or a pageview that only carries a subset of identifiers, must never erase a
    // previously captured raw value) — new values win only for the keys captured just now.
    let existing = {};
    try {
        const match = document.cookie.match(/(?:^|; )marketing=([^;]*)/);
        if (match)
            existing = JSON.parse(decodeURIComponent(match[1]));
    }
    catch (e) { /* malformed/legacy cookie — start fresh rather than throw */ }
    const marketing = { ...existing, ...captured, mappingVersion: 'v2' };
    const expiresDate = new Date();
    expiresDate.setDate(expiresDate.getDate() + 1);
    document.cookie = `marketing=${JSON.stringify(marketing)};expires=${expiresDate};domain=.${config.DOMAIN};path=/`;
}
const LANDING_CONTEXT_COOKIE = 'landing_context';
function isInternalReferrer(referrer) {
    if (!referrer)
        return true;
    try {
        const referrerHost = new URL(referrer).hostname;
        // Any host on our own domain (fe-main, fe-landing, and the blog/jobs/presse subdomains)
        // counts as internal — a referrer from one of our own pages is never a genuine external
        // acquisition source, even though this cookie itself is host-scoped (see below).
        return referrerHost === window.location.hostname
            || referrerHost === config.DOMAIN
            || referrerHost.endsWith(`.${config.DOMAIN}`);
    }
    catch (e) {
        return true; // malformed/unparsable referrer — treat as unusable rather than risk a false "external"
    }
}
function writeLandingContext(landingContext) {
    const expiresDate = new Date();
    expiresDate.setDate(expiresDate.getDate() + 1);
    document.cookie = `${LANDING_CONTEXT_COOKIE}=${JSON.stringify(landingContext)};expires=${expiresDate};path=/`;
}
/**
 * ADV-263: captures the ORIGINAL landing URL and external referrer of a session, ONCE — a
 * deliberately SEPARATE cookie from `marketing`, whose merge-per-key semantics ("newest value
 * wins per key, see setUtmParameters above) are exactly wrong here: landing URL/referrer must
 * be "first wins, never overwritten," not merged. Gated on the cookie's OWN presence rather
 * than "no query params this pageview" (setUtmParameters' gate) — landing context must still
 * be captured on a clean-URL organic entry that carries no query params at all.
 * Host-scoped (no `domain=`) like session_id/cookie_id, not cross-subdomain like `marketing` —
 * the funnel this feeds (SRL/CDP/checkout) is same-host; see plan doc for the reasoning.
 *
 * One landing context per session: `sid` binds the cookie to the session it was captured in. A
 * cookie left from an earlier, expired session is replaced by this page. So a later visit is
 * attributed to its own entry (typed URL, new search result, new referral), not to the first
 * visit of the day. The documented contract is "DIRECT = the visit's own first page has no
 * campaign parameters and no external referrer". The 1-day cookie used to carry
 * the first visit's context into every later session (7% of paid, 6% of organic sessions,
 * 24–27.09.2026). A session that continues in the SPA after 30 idle minutes keeps its landing
 * context; this runs on full page loads only. A cookie without `sid` is adopted by the current
 * session: it was written before this change, or by fe-landing's mobile.js before any session
 * existed. Paid click IDs keep their own 24h window in the `marketing` cookie.
 */
export function setLandingContext() {
    if (isAutomatedAgent())
        return; // crawlers get no landing context, see BotDetection.ts
    const sessionId = CookieUtils.resolveSessionId();
    let existing = null;
    const raw = readCookieValue(LANDING_CONTEXT_COOKIE);
    if (raw) {
        try {
            existing = JSON.parse(raw);
        }
        catch (e) {
            existing = null;
        }
    }
    if (existing && existing.sid === sessionId)
        return; // already captured for this session
    if (existing && !existing.sid) {
        writeLandingContext({ ...existing, sid: sessionId });
        return;
    }
    // isFirstTouch: true only on the request that actually creates this cookie — the one
    // genuine, provable signal that "no referrer" means a real direct entry (typed URL,
    // bookmark) rather than just a request where the referrer happened to be stripped. Persists
    // in the cookie for the rest of the session, so the channel this resolves to (DIRECT or
    // otherwise) is inherited by later events the same way a paid channel's gclid is — see
    // ChannelResolution.ts's resolveChannel().
    const landingContext = {
        landingUrl: window.location.href,
        isFirstTouch: true,
        sid: sessionId,
    };
    if (document.referrer && !isInternalReferrer(document.referrer)) {
        landingContext.externalReferrer = document.referrer;
    }
    writeLandingContext(landingContext);
}
export const toJSTransformer = (obj) => {
    if (obj instanceof ObservableMap) {
        const mapObj = toJS(obj);
        return Object.fromEntries(mapObj);
    }
    else {
        return toJS(obj);
    }
};
